import styled from 'styled-components';

export const StyledWelcomeToThePackContainer = styled.div`
  background: ${props => props.theme.colors.background.lightest};
  border-radius: ${props => props.theme.spacing(7)};
  padding: ${props => props.theme.spacing(5, 4)};
  width: 100%;
  display: flex;
  gap: ${props => props.theme.spacing(4)};
  margin-bottom: ${props => props.theme.spacing(6)};
  ${props => props.theme.typography.body}

  @media ${props => props.theme.tablet} {
    border-radius: ${props => props.theme.spacing(8)};
    padding: ${props => props.theme.spacing(12, 14)};
    max-width: 900px;
  }
`;

export const StyledAppImageContainer = styled.div`
  width: 96px;
  height: 188px;
`;
export const StyledContent = styled.div`
  flex: 7;
  gap: ${props => props.theme.spacing(2)};
`;

export const StyledHeadline = styled.h3`
  color: ${props => props.theme.colors.secondary.yam};
  margin-bottom: ${props => props.theme.spacing(3)};
  ${props => props.theme.typography.subheading1}
`;
export const StyledTitle = styled.h2`
  ${props => props.theme.typography.heading4}
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const StyledBody = styled.p`
  margin-bottom: ${props => props.theme.spacing(4)};
  ${props => props.theme.typography.body}
`;
